import React from 'react'
import ReactEchartsCore from 'echarts-for-react/lib/core';
import echarts from 'echarts/lib/echarts';
import 'echarts/lib/chart/pie'
import 'echarts/lib/component/tooltip'
import 'echarts/lib/component/title'
import 'echarts/lib/component/legend'
import { TradeAmountTodayFields } from "./HomeTypes";

export interface TurnoverPieProps {
  data?: TradeAmountTodayFields[];
}

export const TurnoverPie = (props: any) => {

  // const { data } = props
  // const colors = ['#FE8310', '#FEC410', '#55CE95', '#418DD6', '#2D71F8', '#41D6CB'];
  const {
    xData = [],
    yData = [[], []],
  } = props

  const getOption = () => {
    // let pieData = data?.map((item, index) => {
    //   return { value: item.amount, name: item.tradeTypeName, itemStyle: { color: colors[index] } };
    // });

    return {
      // title: {
      //   text: '当日营业额/应收金额',
      //   left: 20,
      //   textStyle: {
      //     fontSize: 21
      //   }
      // },
      // tooltip: {
      //   trigger: 'item'
      // },
      // legend: {
      //   top: 'center',
      //   left: 'right',
      //   orient: 'vertical'
      // },
      // series: [
      //   {
      //     name: '',
      //     type: 'pie',
      //     radius: ['20%', '50%'],
      //     left: -100,
      //     avoidLabelOverlap: true,
      //     label: {
      //       fontSize: '14px',
      //       lineHeight: 15,
      //       formatter: function (v: any) {
      //         return v.name + '\n' + v.value;
      //       }
      //     },
      //     labelLine: {
      //       length: 10
      //     },
      //     data: pieData
      //   }
      // ]
      title: {
        text: '当日营业额/应收金额',
        textStyle: {
          fontSize: 21
        }
      },
      tooltip: {
        trigger: 'axis'
      },
      grid: {
        left: '3%',
        right: '4%',
        bottom: '3%',
        containLabel: true
      },
      legend: {
        width: 500,
        top: 10,
        right: -5,
        textStyle: {
          fontSize: 16
        }
      },
      barWidth:30,
      toolbox: {
        show: true,
        feature: {
          dataView: { show: true, readOnly: false },
          magicType: { show: true, type: ['line', 'bar'] },
          restore: { show: true },
          saveAsImage: { show: true }
        }
      },
      calculable: true,
      xAxis: [
        {
          type: 'category',
          axisLabel: {
            fontSize: 12,
            color: '#666666',
            rotate: -20,
            interval:0,
          },
          data: xData
        }
      ],
      yAxis: [
        {
          type: 'value'
        }
      ],
      series: [
        {
          name: '营业额',
          type: 'bar',
          data: yData[0],
          markLine: {
            data: [{ type: 'average', name: 'Avg' }]
          }
        },
        {
          name: '应收金额',
          type: 'bar',
          data: yData[1],
          markLine: {
            data: [{ type: 'average', name: 'Avg' }]
          }
        }
      ],
    //   dataZoom: [//给x轴设置滚动条
    //   {
    //     type: 'slider',//slider表示有滑动块的，inside表示内置的
    //     // startValue: 8,//可用于设置开始显示的柱子的长度
    //     // endValue: 1,//可用于设置结束显示的柱子的长度
    //     start: 0,//默认为0  可设置滚动条从在后进行展示
    //     end: 40,//默认为100
    //     show: true,
    //     xAxisIndex: [0],
    //     handleSize: 0,//滑动条的 左右2个滑动条的大小
    //     height: 12,//组件高度
    //     left: '5%', //左边的距离
    //     right: '5%',//右边的距离
    //     bottom: -2,//右边的距离
    //     borderColor: "#6767fa", //两边未选中的滑动条区域的颜色
    //     fillerColor: '#4d90ff',// 两边选中的滑动条区域的颜色
    //     backgroundColor: '#eee',//两边未选中的滑动条区域的颜色
    //     showDataShadow: false,//是否显示数据阴影 默认auto
    //     showDetail: false,//即拖拽时候是否显示详细数值信息 默认true
    //     realtime: true, //是否实时更新
    //     filterMode: 'filter',
    //     handleStyle: {
    //       borderRadius: '20',
    //     },
    //   },
    //   //下面这个属性是里面拖到
    //   {
    //     type: 'inside',
    //     show: true,
    //     xAxisIndex: [0], // 与上面xAxisIndex对应
    //     start: 0,//默认为1
    //     end: 100,//默认为100
    //     moveOnMouseWheel: false, // 鼠标滚轮时是否滚动
    //     preventDefaultMouseMove: false, // 是否阻止默认的鼠标移动事件
    //   },
    // ],
    };
  }

  return (
    <ReactEchartsCore
      echarts={echarts}
      option={getOption() as echarts.EChartOption<echarts.EChartOption.Series>}
      style={{ height: '100%' }}
    />
  )
}